import * as React from 'react'
function SvgIbanfirst(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g fill="none" fillRule="evenodd">
				<path d="M4 4h32v32H4z" />
				<path
					d="M28.597 20.78a5.45 5.45 0 012.639 5 5.993 5.993 0 01-.297.184l-15.477 9.003a5.905 5.905 0 01-3.069.805 5.937 5.937 0 01-2.872-.805 5.99 5.99 0 01-2.13-2.104 5.993 5.993 0 01-.826-2.66v-.043c.847.556 1.859.88 2.946.88.969 0 1.88-.258 2.666-.708l.01-.006.038-.022.419-.244a.089.089 0 01.004-.002zM12.534 4.228a5.892 5.892 0 012.556.607 5.45 5.45 0 00-2.913 4.834v19.103a5.347 5.347 0 01-2.666.707 5.352 5.352 0 01-2.946-.879V9.794a5.995 5.995 0 01.827-2.657A5.99 5.99 0 019.52 5.033a5.94 5.94 0 012.872-.806zm4.106 1.388c.126.062.25.128.371.198l15.478 9.003A5.958 5.958 0 0135.46 20a6.05 6.05 0 01-.743 2.91 5.946 5.946 0 01-1.93 2.09 5.452 5.452 0 00-2.753-5.066l-15.84-9.214-.466-.271a5.45 5.45 0 012.913-4.834z"
					fill="currentColor"
				/>
			</g>
		</svg>
	)
}
export default SvgIbanfirst
